import {Component, computed, inject, input} from '@angular/core';
import {FormControl} from '@angular/forms';
import {TranslatePipe} from '@ngx-translate/core';
import {Dropdown} from '../../../../components/dropdown/dropdown';
import {LicencePlanStore} from '../../services/licence-plan-store';
import {LicencePlanSelect} from '../../../../../api/models';

@Component({
  selector: 'elcia-licence-plan-dropdown',
  imports: [Dropdown, TranslatePipe],
  templateUrl: './licence-plan-dropdown.html',
})
export class LicencePlanDropdown {
  private readonly licencePlanStore = inject(LicencePlanStore);
  protected readonly licencePlans = computed<LicencePlanSelect[]>(() => this.licencePlanStore.licencePlans());
  control = input.required<FormControl>();
}
